import React from 'react';

/** TODO: Re-enable auth check before production deployment */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  // const tokens = getStoredTokens();
  // if (!tokens.accessToken) {
  //   window.location.href = `${WEBSITE_URL}/login`;
  //   return null;
  // }
  return <>{children}</>;
}
